export default __webpack_public_path__ + "static/media/publishers.4030351c.svg";